// STORAGE
export const UPDATE_STORE = 'UPDATE_STORE';
export const RESET_STATE = 'RESET_STATE';
// APPLICATION OPTIONS
export const UPDATE_STEPS = 'UPDATE_STEPS';
export const SET_OWNER_VALIDATION = 'SET_OWNER_VALIDATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const SET_WORDING = 'SET_WORDING';
export const SET_LOADER = 'SET_LOADER';
export const SET_SUPPLIER = 'SET_SUPPLIER';
export const SET_MAX_PANELS = 'SET_MAX_PANELS';
// SELECTION OPTIONS
export const SET_BUILDINGS = 'SET_BUILDINGS';
export const SET_BUILDING = 'SET_BUILDING';
export const SET_ACTIVE_BUILDING = 'SET_ACTIVE_BUILDING';
export const SET_ACTIVE_FIELD = 'SET_ACTIVE_FIELD';
export const SET_PANELS = 'SET_PANELS';
// PANEL OPTIONS
export const UPDATE_PANEL_PRICE = 'UPDATE_PANEL_PRICE';
export const SET_SELECTED_PANEL = 'SET_SELECTED_PANEL';
export const REMOVE_SELECTED_PANEL = 'REMOVE_SELECTED_PANEL';
export const ERASE_SELECTED_PANEL = 'ERASE_SELECTED_PANEL';
export const UPDATE_PANEL_NAME = 'UPDATE_PANEL_NAME';
export const UPDATE_PANEL_STATUS = 'UPDATE_PANEL_STATUS';
// PANEL STATUSES
export const PANEL_AVAILABLE = 1;
export const PANEL_LOCKED = 2;
export const PANEL_RESERVED = 3;
export const PANEL_TAKEN = 4;

// OWNER OPTIONS
export const TOGGLE_OWNER_PANEL = 'TOGGLE_OWNER_PANEL';
export const SET_OWNER = 'SET_OWNER';
// PANEL OPTIONS
export const SET_CUSTOMER = 'SET_CUSTOMER';
// ORDER
export const ORDER_CREATED = 'ORDER_CREATED';
// RESOURCES
export const UPDATE_PDF = 'UPDATE_PDF';



// WEBPACK FOOTER //
// ./src/store/types.js